import RouterProvider  from '@/RouterProvider';

export default function App() {
	return <RouterProvider />;
}
